<!-- App.vue -->
<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	
</script>
<style>
	.flex {
		display: flex;
	}

	.alit {
		align-items: center;
	}

	.justc {
		justify-content: center;
	}

	.justb {
		justify-content: space-between;
	}

	.flexCol {
		display: flex;
		flex-direction: column;
	}

	.textOne {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		padding: 0;
	}

	.pointer {
		cursor: pointer;
	}

	body {
		padding: 0 !important;
		margin: 0 !important;
	}
	
	
	.commpany-desc{
		font-size: 17px;
		text-indent: 4ch;
		color: #fff;
		line-height: 32px;
		letter-spacing: 1px;
	}
	.commpany-desc-us{
		font-size: 10px;
		text-indent: 4ch;
		color: #fff;
		line-height: 17px;
		margin-top: 20px;
	}
	.commpany-name{
		font-size: 40px;
		font-weight: 500;
		color: #fff;
		margin-bottom: 20px;
	}
	
</style>